function a(n) {
  var r = [];
  if (n != null)
    for (var e in Object(n))
      r.push(e);
  return r;
}
var t = a;
export {
  t as _
};
//# sourceMappingURL=_nativeKeysIn.js.map
